import { Component, OnInit } from '@angular/core';

// Interface to define the structure of our data
export interface CarData {
  modelUsed: string;
  visits: number;
  sold: number;
  g: number;
  f: number;
  a: number;
}

@Component({
  selector: 'app-vehicle-sold-table',
  templateUrl: './vehicle-sold-table.component.html',
  styleUrls: ['./vehicle-sold-table.component.scss']
})
export class VehicleSoldTableComponent implements OnInit {

  // Array holding the data extracted from the image
  carDataList: CarData[] = [
    { modelUsed: 'Rav4 Plug-in', visits: 2, sold: 0, g: 2, f: 0, a: 0 },
    { modelUsed: 'RAV4', visits: 1, sold: 0, g: 1, f: 4, a: 26 },
    { modelUsed: 'Rav4 Hybrid', visits: 0, sold: 0, g: 0, f: 4, a: 15 },
    { modelUsed: 'Tacoma', visits: 2, sold: 2, g: 63, f: 16, a: 5 },
    { modelUsed: 'Tacoma Hybrid', visits: 0, sold: 0, g: 7, f: 0, a: 10 },
    { modelUsed: 'Camry', visits: 1, sold: 0, g: 0, f: 12, a: 13 },
    { modelUsed: 'Corolla', visits: 0, sold: 0, g: 0, f: 3, a: 2 },
    { modelUsed: 'Corolla Hybrid', visits: 0, sold: 0, g: 1, f: 1, a: 10 },
    { modelUsed: 'Corolla Hatchback', visits: 0, sold: 0, g: 1, f: 0, a: 1 },
    { modelUsed: '4Runner', visits: 2, sold: 0, g: 3, f: 2, a: 1 },
    { modelUsed: 'Tundra', visits: 2, sold: 1, g: 14, f: 1, a: 6 },
    { modelUsed: 'Tundra Hybrid', visits: 0, sold: 0, g: 4, f: 9, a: 3 },
    { modelUsed: 'Sienna', visits: 0, sold: 0, g: 0, f: 0, a: 0 },
    { modelUsed: 'Corolla Cross', visits: 2, sold: 1, g: 3, f: 8, a: 4 },
    { modelUsed: 'Corolla Cross Hybrid', visits: 0, sold: 0, g: 0, f: 2, a: 9 },
    { modelUsed: 'Prius', visits: 0, sold: 0, g: 3, f: 2, a: 3 },
    { modelUsed: 'Prius Plug-in', visits: 0, sold: 0, g: 8, f: 0, a: 7 },
    { modelUsed: 'Sequoia', visits: 0, sold: 0, g: 2, f: 3, a: 1 },
    { modelUsed: 'bZ4X', visits: 2, sold: 0, g: 16, f: 2, a: 14 },
    { modelUsed: 'Crown', visits: 0, sold: 0, g: 0, f: 1, a: 0 },
    { modelUsed: 'Highlander', visits: 2, sold: 0, g: 1, f: 0, a: 1 },
    { modelUsed: 'Highlander Hybrid', visits: 0, sold: 0, g: 1, f: 0, a: 0 },
    { modelUsed: 'Grand Highlander', visits: 2, sold: 1, g: 1, f: 2, a: 2 },
    { modelUsed: 'Grand Highlander Hybrid', visits: 1, sold: 1, g: 0, f: 0, a: 2 },
    { modelUsed: 'GR Corolla', visits: 2, sold: 1, g: 1, f: 0, a: 0 },
    { modelUsed: 'Land Cruiser HV', visits: 0, sold: 0, g: 0, f: 0, a: 2 },
    { modelUsed: 'Crown Signia', visits: 0, sold: 0, g: 0, f: 0, a: 0 },
    { modelUsed: 'GR86', visits: 0, sold: 0, g: 0, f: 0, a: 2 },
    { modelUsed: 'Street Purchase', visits: 0, sold: 0, g: 0, f: 0, a: 2 }
  ];


  constructor() { }

  ngOnInit(): void {
  }

}
